document.addEventListener("DOMContentLoaded",function(){
	init();
});

const init = () => {
	// code that will run on init...
	mobileMenu();

	mobileNavigation();

	accordionPanels();

	blogFilters();

	eddBlocks();

	tbhMembersMenuDropwdown();

	tbhCheckoutUSAOnly();

	oldTbhCourseDropdowns();

	tbhMyAccountPage();
};

function tbhMembersMenuDropwdown() {
	const memberDropdownBtn = document.getElementById('tbh-member-dropdown-button');
	
	if(memberDropdownBtn) {

		memberDropdownBtn.addEventListener('click', function() {
			const parentMenuItem = memberDropdownBtn.parentElement;

			if(parentMenuItem.classList.contains('active')) {
				memberDropdownBtn.setAttribute('aria-expanded', false);
				parentMenuItem.classList.toggle('active');
			} else {
				memberDropdownBtn.setAttribute('aria-expanded', true);
				parentMenuItem.classList.toggle('active');
			}
		});
	}
}


const eddBlocks = () => {
	const eddRecommendedProductBlocks = document.querySelectorAll('.tbh-recommended-product__text__wrap');
	if(eddRecommendedProductBlocks) {

		eddRecommendedProductBlocks.forEach(productBlock => {
			const headerInputs = productBlock.querySelectorAll('.tbh-recommended-product__text__header input');
			if(headerInputs) {
				headerInputs.forEach(eddInput => {

					eddInput.addEventListener('click', () => {
						if(document.querySelector('.tbh-recommended-product__buttons #' + eddInput.id +'-2')) {
							document.querySelector('.tbh-recommended-product__buttons #' + eddInput.id +'-2').click();
						}

					});

				});
			}
		});

	}
};




const mobileMenu = () => {
	const mobileMenuButtons = document.querySelectorAll('.js-mobile-menu-toggle');
	const navigation = document.getElementById('tbh-header-menu-wrap');

	const mobileMenuToggle = event => {
		const buttonClicked = event.target;

		if( navigation.classList.contains('open')){
			// close
			buttonClicked.classList.remove("open");
			navigation.classList.remove("open");
			buttonClicked.setAttribute('aria-expanded', false);
			document.querySelector('body').style.overflow = 'auto';
		} else {
			// open
			buttonClicked.classList.add("open");
			navigation.classList.add("open");
			buttonClicked.setAttribute('aria-expanded', true);
			document.querySelector('body').style.overflow = 'hidden';
		}
	};

	mobileMenuButtons.forEach((val, id) => {
		val.addEventListener('click', (event) => {
			mobileMenuToggle(event);
		});
	});
};



function mobileNavigation() {
	const mobileDropdownButtons = document.querySelectorAll('.mobile-nav-dropdown-btn');

	if(mobileDropdownButtons.length > 0) {
		mobileDropdownButtons.forEach(dropdownBtn => {
			dropdownBtn.addEventListener('click', function() {
				const parentMenuItem = dropdownBtn.parentElement;
				const thisSubMenu = parentMenuItem.querySelector('.sub-menu');

				if(thisSubMenu.classList.contains('active')){                      
					  parentMenuItem.classList.remove('active');
					  thisSubMenu.classList.remove('active');


				} else {

					  if(document.querySelector('.sub-menu.active')) {
							document.querySelectorAll('.sub-menu').forEach(subMenu => {
								  subMenu.classList.remove('active');
							});
							document.querySelectorAll('.menu-item-has-children').forEach(subMenu => {
								  subMenu.classList.remove('active');
							});
					  }


					  parentMenuItem.classList.add('active');
					  thisSubMenu.classList.add('active');
				}
			});
		});
	}
}



const accordionPanels = () => {
	if(document.querySelector('.tbh-accordion-panel')) {
		const tbhAccordionPanelBtns = document.querySelectorAll('.tbh-accordion-panel__button');

		// Add event listener to all accordion buttons on page
		tbhAccordionPanelBtns.forEach(btn => {
			const thisAccordionItem = btn.parentElement;

			btn.addEventListener('click', () => {

				if(thisAccordionItem.classList.contains('tbh-accordion-panel--active')) {
					// close
					thisAccordionItem.classList.remove('tbh-accordion-panel--active');
					btn.setAttribute('aria-expanded', false);
				} else {
					// open
					if(document.querySelector('.tbh-accordion-panel--active')) {
						document.querySelector('.tbh-accordion-panel--active').classList.remove('tbh-accordion-panel--active');
					}

					thisAccordionItem.classList.add('tbh-accordion-panel--active');
					btn.setAttribute('aria-expanded', true);
				}

			});
		});

		// Open first panel on page load
		document.querySelector('.tbh-accordion-panel__button').click();
	}
};





const blogFilters = () => {

	if(document.getElementById('tbh-blog-cats-filter-btn')) {
		const blogFilterBtn = document.getElementById('tbh-blog-cats-filter-btn');
		const blogFilterMenu = document.getElementById('tbh-blog-filter-cats');

		blogFilterBtn.addEventListener('click', () => {
			if(blogFilterMenu.classList.contains('active')) {

				document.querySelector('.tbh-blog-filter-btn.active').setAttribute('aria-expanded', false);
				document.querySelector('.tbh-blog-filter-btn.active').classList.remove('active');
				blogFilterMenu.classList.remove('active');

			} else {
				
				document.addEventListener('keydown', evt => {
					if (evt.key === 'Escape') {
						if(blogFilterMenu.classList.contains('active')) {
							document.querySelector('.tbh-blog-filter-btn.active').setAttribute('aria-expanded', false);
							document.querySelector('.tbh-blog-filter-btn.active').classList.remove('active');
							document.querySelector('.tbh-blog-filter-dropdown.active').classList.remove('active');
						}
					}
				});

				if(document.querySelector('.tbh-blog-filter-btn.active')) {
					document.querySelector('.tbh-blog-filter-btn.active').setAttribute('aria-expanded', false);
					document.querySelector('.tbh-blog-filter-btn.active').classList.remove('active');
					document.querySelector('.tbh-blog-filter-dropdown.active').classList.remove('active');
				}

				blogFilterMenu.classList.add('active');
				blogFilterBtn.classList.add('active');
				blogFilterBtn.setAttribute('aria-expanded', true);
			}
		});
	}


	if(document.getElementById('tbh-blog-author-filter-btn')) {
		const blogAuthorFilterBtn = document.getElementById('tbh-blog-author-filter-btn');
		const blogAuthorFilterMenu = document.getElementById('tbh-blog-filter-authors');

		blogAuthorFilterBtn.addEventListener('click', () => {

			if(blogAuthorFilterMenu.classList.contains('active')) {
				document.querySelector('.tbh-blog-filter-btn.active').setAttribute('aria-expanded', false);
				document.querySelector('.tbh-blog-filter-btn.active').classList.remove('active');
				blogAuthorFilterMenu.classList.remove('active');
			} else {

				if(document.querySelector('.tbh-blog-filter-btn.active')) {
					document.querySelector('.tbh-blog-filter-btn.active').setAttribute('aria-expanded', false);
					document.querySelector('.tbh-blog-filter-btn.active').classList.remove('active');
					document.querySelector('.tbh-blog-filter-dropdown.active').classList.remove('active');
				}


				blogAuthorFilterMenu.classList.add('active');
				blogAuthorFilterBtn.classList.add('active');
				blogAuthorFilterBtn.setAttribute('aria-expanded', true);
			}

		});
	}
};



function tbhCheckoutUSAOnly() {
	const usaOnlyShippingModal = document.getElementById('usaOnlyShippingModal');

	const closeTbhShippingModal = () => {
		usaOnlyShippingModal.classList.remove('active');
		usaOnlyShippingModal.setAttribute('aria-hidden', true);
	};

	if(usaOnlyShippingModal) {
		const eddCheckoutFormWrap = document.getElementById('edd_checkout_form_wrap');
		const eddSimpleShippingFieldset = document.getElementById('edd_simple_shipping_diff_address');
		const eddCheckoutSubmitButton = document.getElementById('edd-purchase-button');

		if(eddCheckoutFormWrap && eddSimpleShippingFieldset) {



			const eddCountrySelect = document.getElementById('billing_country');
			const eddShippingCountrSelect = document.querySelector('.shipping-country.edd-select');

			document.addEventListener('keydown', evt => {
				if (evt.key === 'Escape') {
					closeTbhShippingModal();
				}
			});


			eddCountrySelect.addEventListener('change', () => {
				if(eddCountrySelect.value !== 'US') {

					eddCheckoutSubmitButton.style.pointerEvents = 'none';
					eddCheckoutSubmitButton.style.backgroundColor = '#CCCCCC';

					usaOnlyShippingModal.classList.add('active');
					usaOnlyShippingModal.setAttribute('aria-hidden', false);

					document.getElementById('usaOnlyShippingModalClose').addEventListener('click', () => {
						closeTbhShippingModal();
					});
					

				} else {

					eddCheckoutSubmitButton.style.pointerEvents = 'auto';
					eddCheckoutSubmitButton.style.backgroundColor = '#001F39';

				}
				
			});

			eddShippingCountrSelect.addEventListener('change', () => {
				if(eddShippingCountrSelect.value === 'US') {

					closeTbhShippingModal();

					eddCheckoutSubmitButton.style.pointerEvents = 'auto';
					eddCheckoutSubmitButton.style.backgroundColor = '#001F39';

				} else {

					eddCheckoutSubmitButton.style.pointerEvents = 'none';
					eddCheckoutSubmitButton.style.backgroundColor = '#CCCCCC';

					usaOnlyShippingModal.classList.add('active');
					usaOnlyShippingModal.setAttribute('aria-hidden', false);

					document.getElementById('usaOnlyShippingModalClose').addEventListener('click', () => {

						closeTbhShippingModal();

					});

				}
			});

		}
	}
}


function oldTbhCourseDropdowns() {
	
	const tbhCourseDropdowns = document.querySelectorAll('.worksheetsList');

	if(tbhCourseDropdowns) {

		tbhCourseDropdowns.forEach(dropdown => {
			dropdown.addEventListener('click', () => {

				if(dropdown.querySelector('.dropdown').classList.contains('active')) {
					dropdown.querySelector('.dropdown').classList.remove('active');
				} else {
					dropdown.querySelector('.dropdown').classList.add('active');
				}

			});
		});
	}
}


function tbhMyAccountPage() {

	// Hide the "No Purchases" message if there are subscriptions
	if(document.querySelector('.edd-no-purchases') && document.querySelector('.edd-subscriptions-heading')) {
		document.querySelector('.edd-subscriptions-heading').style.display = 'none';
	}
}